module.exports = __webpack_public_path__ + "img/switch-comp-light-mixed-01.ffaa9a59.svg";